const TIRE_DISPOSAL_LINE_ITEM_NAME = 'State Tire Fee';
const TIRE_DISPOSAL_LINE_ITEM_SKU = 'TIRE-DISPOSAL-FEE';

const AMOUNT_REPLACE_PATH = '/purchase_units/@reference_id==\'default\'/amount';

function parsePayPalMoneyAmount(value) {
	const amount = Number.parseFloat(value);
	return Number.isFinite(amount) ? amount : 0;
}

function formatPayPalMoneyAmount(value) {
	return parsePayPalMoneyAmount(value).toFixed(2);
}

function buildTireDisposalLineItemPatch(currencyCode, tireDisposalFeeAmount) {
	const tireFee = parsePayPalMoneyAmount(tireDisposalFeeAmount);
	if (tireFee <= 0) {
		return null;
	}

	return {
		op: 'add',
		path: '/purchase_units/@reference_id==\'default\'/items/-',
		value: {
			category: 'DIGITAL_GOODS',
			name: TIRE_DISPOSAL_LINE_ITEM_NAME,
			quantity: '1',
			sku: TIRE_DISPOSAL_LINE_ITEM_SKU,
			unit_amount: {
				currency_code: currencyCode,
				value: formatPayPalMoneyAmount(tireFee),
			},
		},
	};
}

/**
 * @param {{
 *   currencyCode: string,
 *   subtotalAmount: number | string,
 *   taxAmount: number | string,
 *   shippingAmount: number | string,
 *   handlingAmount: number | string,
 *   discountAmount: number | string,
 *   deliveryFeeAmount: number | string,
 *   tireDisposalFeeAmount: number | string,
 *   totalAmount: number | string,
 *   tireDisposalLineItemAlreadyAdded: boolean,
 * }} params
 * @returns {Array<object>}
 */
export function buildPayPalShippingPatchData({
	currencyCode,
	subtotalAmount,
	taxAmount,
	shippingAmount,
	handlingAmount,
	discountAmount,
	deliveryFeeAmount,
	tireDisposalFeeAmount,
	totalAmount,
	tireDisposalLineItemAlreadyAdded,
}) {
	const tireFee = parsePayPalMoneyAmount(tireDisposalFeeAmount);
	const itemTotalAmount = formatPayPalMoneyAmount(parsePayPalMoneyAmount(subtotalAmount) + tireFee);
	const tireDisposalLineItemPatch = tireFee > 0 && !tireDisposalLineItemAlreadyAdded
		? buildTireDisposalLineItemPatch(currencyCode, tireDisposalFeeAmount)
		: null;

	const patchData = [
		{
			op: 'replace',
			path: AMOUNT_REPLACE_PATH,
			value: {
				currency_code: currencyCode,
				value: totalAmount,
				breakdown: {
					item_total: {
						currency_code: currencyCode,
						value: itemTotalAmount,
					},
					tax_total: {
						currency_code: currencyCode,
						value: taxAmount,
					},
					shipping: {
						currency_code: currencyCode,
						value: shippingAmount,
					},
					handling: {
						currency_code: currencyCode,
						value: handlingAmount,
					},
					discount: {
						currency_code: currencyCode,
						value: discountAmount,
					},
					delivery_fee: {
						currency_code: currencyCode,
						value: deliveryFeeAmount,
					},
				},
			},
		},
	];

	if (tireDisposalLineItemPatch) {
		patchData.push(tireDisposalLineItemPatch);
	}

	return {
		addedTireDisposalLineItem: tireDisposalLineItemPatch !== null,
		patchData,
	};
}
